module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/logo5.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "leading"
  }, [_vm._v("アイリッシュセットダンスをもっと楽しむためのリファレンスサイト"), _c('br'), _vm._v("\n  （はじめての方は"), _c('router-link', {
    attrs: {
      "to": {
        name: 'ForVisitor'
      }
    }
  }, [_vm._v("こちら")]), _vm._v("をお読みください）")], 1), _vm._v(" "), _c('md-subheader', [_vm._v("お知らせ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getNews),
      expression: "getNews"
    }],
    staticClass: "news"
  }, [_c('md-chip', [_vm._v(_vm._s(_vm.getNews))])], 1), _vm._v(" "), _c('md-subheader', [_vm._v("ダンスの記事")]), _vm._v(" "), _c('md-list', {
    staticClass: "md-double-line"
  }, _vm._l((_vm.getReversedArticles), function(article, index) {
    return _c('md-list-item', {
      key: index
    }, [_c('div', {
      staticClass: "md-list-text-container"
    }, [_c('span', [_c('a', {
      attrs: {
        "href": article.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(article.title))])]), _vm._v(" "), (article.genre === 'SetDance') ? _c('span', {
      key: "articleSetDance",
      staticClass: "md-primary type-of-event"
    }, [_vm._v("セットダンス")]) : (article.genre === 'SeanNos') ? _c('span', {
      key: "articleSeanNos",
      staticClass: "md-accent type-of-event"
    }, [_vm._v("シャンノース")]) : (article.genre === 'CeiliDance') ? _c('span', {
      key: "articleSeanNos",
      staticClass: "md-accent type-of-event"
    }, [_vm._v("ケーリーダンス")]) : (article.genre === 'OldStyleStepDance') ? _c('span', {
      key: "articleSeanNos",
      staticClass: "md-accent type-of-event"
    }, [_vm._v("オールドスタイル")]) : (article.genre === 'ModernStyleStepDance') ? _c('span', {
      key: "articleSeanNos",
      staticClass: "md-accent type-of-event"
    }, [_vm._v("モダンスタイル")]) : (article.genre === 'Others') ? _c('span', {
      key: "articleOthers",
      staticClass: "md-primary type-of-event"
    }, [_vm._v("その他")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(article.description) + " by " + _vm._s(article.writers) + "\n        ")])]), _vm._v(" "), _c('md-divider')], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "event-controller"
  }, [_c('router-link', {
    staticClass: "md-raised md-primary",
    attrs: {
      "tag": "md-button",
      "to": {
        name: 'AddArticle'
      }
    }
  }, [_vm._v("記事のリンクを追加する")]), _vm._v(" "), _c('router-link', {
    staticClass: "md-raised",
    attrs: {
      "tag": "md-button",
      "to": {
        name: 'AllArticles'
      }
    }
  }, [_vm._v("すべての記事をみる")])], 1), _vm._v(" "), _c('md-subheader', [_vm._v("開催予定のイベント")]), _vm._v(" "), _c('md-list', {
    staticClass: "md-double-line"
  }, _vm._l((_vm.events), function(event, index) {
    return _c('md-list-item', {
      key: index
    }, [_c('div', {
      staticClass: "md-list-text-container"
    }, [_c('span', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Event',
          params: {
            eventId: event.id
          }
        }
      }
    }, [_vm._v("\n            " + _vm._s(event.name) + "\n          ")])], 1), _vm._v(" "), _c('span', {
      staticClass: "jpCaption"
    }, [_vm._v("\n          " + _vm._s(event.host) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(_vm.getEventSchedule(event.startTime, event.endTime)) + "\n        ")])]), _vm._v(" "), (event.type === 'Class') ? _c('md-chip', {
      key: "eventClass",
      staticClass: "md-primary type-of-event"
    }, [_vm._v("クラス")]) : (event.type === 'Céilí') ? _c('md-chip', {
      key: "eventCeili",
      staticClass: "md-accent type-of-event"
    }, [_vm._v("ケーリー")]) : (event.type === 'SessionOrDance') ? _c('md-chip', {
      key: "eventCeili",
      staticClass: "md-primary type-of-event"
    }, [_vm._v("セッション/ダンス")]) : _vm._e(), _vm._v(" "), _c('md-divider')], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "event-controller"
  }, [_c('router-link', {
    staticClass: "md-raised md-primary",
    attrs: {
      "tag": "md-button",
      "to": {
        name: 'AddEvent'
      }
    }
  }, [_vm._v("イベントを作成する")]), _vm._v(" "), _c('router-link', {
    staticClass: "md-raised",
    attrs: {
      "tag": "md-button",
      "to": {
        name: 'NextEvents'
      }
    }
  }, [_vm._v("その他のイベントをみる")])], 1), _vm._v(" "), _c('md-subheader', [_vm._v("セットリスト")]), _vm._v(" "), _c('md-input-container', {
    attrs: {
      "md-clearable": ""
    }
  }, [_c('md-icon', [_vm._v("search")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "serachField",
      "placeholder": "セットを検索する"
    },
    on: {
      "input": function($event) {
        _vm.searchSet($event)
      }
    },
    model: {
      value: (_vm.searchKey),
      callback: function($$v) {
        _vm.searchKey = $$v
      },
      expression: "searchKey"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.sets), function(set, index) {
    return _c('md-list', {
      key: index,
      staticClass: "md-double-line"
    }, [(!_vm.existsSubHeader(set.name)) ? _c('md-divider') : _vm._e(), _vm._v(" "), (_vm.existsSubHeader(set.name)) ? _c('md-subheader', [_vm._v(_vm._s(set.name.substr(0, 1)))]) : _vm._e(), _vm._v(" "), _c('md-list-item', [_c('md-avatar', {
      staticClass: "md-large"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Set',
          params: {
            setName: set.name
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": set.figures[0].youtube ? _vm.getThumbnail(set.figures[0].youtube.url) : _vm.getThumbnail(set.thumbnail),
        "alt": "Thumbnail"
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "md-list-text-container"
    }, [_c('span', [(set.needsSet) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'Set',
          params: {
            setName: set.name
          }
        }
      }
    }, [_vm._v("\n            " + _vm._s(set.name) + " Set\n          ")]) : _c('router-link', {
      attrs: {
        "to": {
          name: 'Set',
          params: {
            setName: set.name
          }
        }
      }
    }, [_vm._v("\n            " + _vm._s(set.name) + "\n          ")])], 1), _vm._v(" "), (set.needsSet) ? _c('span', {
      staticClass: "jpCaption"
    }, [_vm._v("\n          " + _vm._s(set.jpCaption) + "・セット\n        ")]) : _c('span', {
      staticClass: "jpCaption"
    }, [_vm._v("\n          " + _vm._s(set.jpCaption) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(_vm.getDescription(set)) + "\n        ")])])], 1)], 1)
  }), _vm._v(" "), _c('md-list', [_c('md-list-item', [_c('md-avatar', {
    staticClass: "md-large"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'SoldiersSong'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/ireland.gif",
      "alt": "Thumbnail"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'SoldiersSong'
      }
    }
  }, [_vm._v("\n            Amhrán na bhFiann\n          ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "jpCaption"
  }, [_vm._v("\n          兵士の歌\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          March - March - March\n        ")])])], 1), _vm._v(" "), _c('md-list-item', [_c('md-avatar', {
    staticClass: "md-large"
  }), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Shinano'
      }
    }
  }, [_vm._v("\n            信濃の国\n          ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "jpCaption"
  }, [_vm._v("\n          Shinano-no-kuni\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          March - March - March - March - March - March\n        ")])])], 1)], 1), _vm._v(" "), _c('md-divider'), _vm._v(" "), _c('div', {
    staticClass: "event-controller"
  }, [_c('router-link', {
    staticClass: "md-raised",
    attrs: {
      "tag": "md-button",
      "to": {
        name: 'AllEvent'
      }
    }
  }, [_vm._v("過去のイベントをみる")]), _vm._v(" "), _c('router-link', {
    staticClass: "md-raised md-primary",
    attrs: {
      "tag": "md-button",
      "to": {
        name: 'AddEvent'
      }
    }
  }, [_vm._v("イベントを作成する")])], 1), _vm._v(" "), _c('p', {
    staticClass: "page-description"
  }, [_vm._v("イベントはどなたでも作成することができます。セットダンスに関わるイベントであればご自由にご登録ください。CCÉと自分が参加予定のイベントは城が登録することがあります。もし不都合がありましたら城までご連絡ください。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "page-description"
  }, [_vm._v("日本語でかかれたアイリッシュダンスの記事を集めたAndroidアプリ「ダンスノーツ」をリリースしました。よかったらダウンロードしてね！")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('md-divider'), _vm._v(" "), _c('footer', [_c('router-link', {
    attrs: {
      "to": {
        name: 'About'
      }
    }
  }, [_vm._v("\n      このサイトについて\n    ")])], 1)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=jp.setdancepal.irishdancenotes&hl=fa&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Google Play で手に入れよう",
      "width": "200",
      "src": "https://play.google.com/intl/ja/badges/static/images/badges/ja_badge_web_generic.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97badc2c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 340
// module chunks = 1